import type { Restaurant, RestaurantDetails } from "@/API";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { XIcon } from "lucide-react";
import { type FC } from "react";
import {
  removeUserRestaurant,
  userRemoveRestaurantState,
} from "@/store/userRemoveRestaurantState";
import { useTranslation } from "react-i18next";

type Props = {
  open: boolean;
  restaurant?: RestaurantDetails | Restaurant;
  onClose: () => void;
};

const RemoveRestaurantDialog: FC<Props> = ({ open, onClose, restaurant }) => {
  const { isLoading: removingRestaurant } = userRemoveRestaurantState();
  const { t } = useTranslation();

  if (!restaurant) return null;

  return (
    <Dialog open={open}>
      <DialogContent showCloseButton={false}>
        <DialogHeader>
          <div className="flex justify-between">
            <DialogTitle>{t("delete_restaurant")}</DialogTitle>
            <XIcon className="cursor:pointer" onClick={() => onClose()} />
          </div>
        </DialogHeader>

        <DialogDescription>
          {t("would_you_delete_restaurant", {
            restaurantName: restaurant.name,
          })}
        </DialogDescription>

        <DialogFooter>
          <Button variant="secondaryFilled" onClick={() => onClose()}>
            {t("cancel")}
          </Button>
          <Button
            disabled={removingRestaurant}
            variant="dangerFilled"
            onClick={() => {
              removeUserRestaurant(restaurant.id);
            }}
          >
            {t("delete")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RemoveRestaurantDialog;
